export enum PenetranceLevel {
    Uncertain = "Uncertain",
    Low = "Low",
    Moderate = "Moderate",
    High = "High",
}
